import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

export namespace S25ReactiveForms {
    export function getDirtyValues<Value>(formItem: AbstractControl<Value>): Value {
        if (!formItem.dirty) return;
        if (formItem instanceof FormControl) {
            return formItem.value as Value;
        } else if (formItem instanceof FormArray) {
            const values: any[] = [];
            for (const key in formItem.controls) {
                values[Number(key)] = getDirtyValues(formItem.controls[key]);
            }
            return values as Value;
        } else if (formItem instanceof FormGroup) {
            const values: Record<PropertyKey, any> = {};
            for (const key in formItem.controls) {
                values[key] = getDirtyValues(formItem.controls[key]);
            }
            return values as Value;
        }
    }
}
